import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { theme } from "antd";
const { useToken } = theme;
/**
 * Icon for the warning severity.
 */
export default function WarningIcon() {
    const { token } = useToken();
    return (_jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("path", { d: "M12 1.5c5.799 0 10.5 4.701 10.5 10.5S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5Zm0 2a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Z", fill: token.colorWarning }), _jsx("path", { fill: token.colorWarningText, d: "M10.875 16.125a1.125 1.125 0 1 0 2.25 0 1.125 1.125 0 0 0-2.25 0Zm.563-2.625h1.124a.188.188 0 0 0 .188-.188V6.939a.188.188 0 0 0-.188-.188h-1.124a.188.188 0 0 0-.188.188v6.375c0 .103.084.187.188.187Z" })] }));
}
